module.exports = __webpack_public_path__ + "static/img/3-2-1.5165beae.jpg";